import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { useAuth } from '../../../modules/auth/core/Auth'
import { getDevicesByOrganization } from '../../../../api/devicesApi'
import { KTSVG } from '../../../../_metronic/helpers'
import MirroringStream from '../MirroringStream';

interface Device {
  ID_Device: number
  Android_ID: string
  Nome: string
}

const Conferenza: React.FC = () => {
  // 1) Ottieni l’organizzazione attiva
  const { activeOrganization, currentUser, auth } = useAuth()

  // 2) Stato per aprire/chiudere il modal
  const [showModal, setShowModal] = useState(false)

  // 3) Stato per la lista dei device disponibili
  const [devices, setDevices] = useState<Device[]>([])

  // 4) Stato per il device attualmente selezionato
  const [selectedDevice, setSelectedDevice] = useState<Device | null>(null)

  // 5) Stato per codice d’accesso a 6 cifre
  const [accessCode, setAccessCode] = useState('')

  // 6) Carica la lista dei device associati all’organizzazione attiva
  useEffect(() => {
    async function fetchDevicesByOrg() {
      if (activeOrganization) {
        try {
          const response = await getDevicesByOrganization(activeOrganization.ID_Organizzazione)
          setDevices(response)  // se l’API restituisce array di {ID_Device, Android_ID, Nome, ...}
        } catch (err) {
          console.error('Errore nel fetch dei device:', err)
        }
      }
    }

    fetchDevicesByOrg()
  }, [activeOrganization])

  // 7) Funzioni per aprire/chiudere il modal
  const handleOpenModal = () => {
    setShowModal(true)
  }
  const handleCloseModal = () => {
    setShowModal(false)
  }

  // 8) Genera codice a 6 cifre
  const generateAccessCode = async () => {
    if (!selectedDevice) return
    try {
      const API_BASE = process.env.REACT_APP_API_BASE ?? '/external-api'
      const res = await fetch(`${API_BASE}/sessione-mirroring`, {         // endpoint reale
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth?.api_token}`                    // se usi il JwtAuthGuard
        },
        body: JSON.stringify({
          sessionId: selectedDevice.Android_ID,
          COD_Device: selectedDevice.ID_Device,
          COD_User_SM: currentUser?.ID_User,                              // ricava dall’autenticazione
        })
      })

      if (!res.ok) throw new Error('Impossibile generare il PIN')

      const payload = await res.json()
      console.log('payload ricevuto →', payload)
      setAccessCode(payload.session?.pin || payload.session?.Passkey || '')
    } catch (err) {
      console.error(err)
    }
  }

  // 9) Quando l’utente fa “Salva” nel modal
  const handleSave = () => {
    // Esempio: potresti salvare da qualche parte (es. DB) la configurazione,
    // associando selectedDevice e accessCode
    // ...
    setShowModal(false)
  }

  return (
    <div>
      {/* Barra in alto con device selezionato */}
      <div className='d-flex justify-content-between align-items-center mb-4'>
      {selectedDevice ? (
        <div>
          <h2>Device selezionato:</h2>
          <h2>{selectedDevice.Nome}</h2>
        </div>
      ) : (
        <h2>Nessun device selezionato</h2>
      )}
        <button className='btn btn-primary' onClick={handleOpenModal}>
          <i className='bi bi-pencil me-2' />
          Configura
        </button>
      </div>

      {/* Box dove andrà il mirroring */}
      <div style={{
        marginTop: '30px',
        width: '100%',
        height: '500px',
        backgroundColor: '#000000',
        color: 'white',
        fontSize: '20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        {(selectedDevice && accessCode) ? (
          <MirroringStream sessionId={selectedDevice?.Android_ID} isInitiator={false} />
        ) : (
          <p style={{ margin: 0, textAlign: 'center' }}>Seleziona un device per avviare il mirroring</p>
        )}
      </div>

      {/* Modal in stile Metronic simile a GridConfiguratorModal */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        dialogClassName='modal-dialog modal-dialog-centered mw-900px'
      >
        <div className='modal-header'>
          <h2>Configura Mirroring</h2>
          <div
            className='btn btn-sm btn-icon btn-active-color-primary'
            onClick={handleCloseModal}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
          </div>
        </div>

        <div className='modal-body'>
          {/* step 1: seleziona device */}
          <div className='mb-10'>
            <label className='form-label mb-2'>Seleziona un visore</label>
            <select
              className='form-select form-select-solid'
              value={selectedDevice?.ID_Device ?? ''}
              onChange={(e) => {
                const devId = parseInt(e.target.value, 10)
                const found = devices.find((d) => d.ID_Device === devId) || null
                setSelectedDevice(found)
              }}
            >
              <option value=''>-- Nessuno --</option>
              {devices.map((dev) => (
                <option key={dev.ID_Device} value={dev.ID_Device}>
                  {dev.Nome}
                </option>
              ))}
            </select>
          </div>

          {/* step 2: codice di accesso */}
          <div className='mb-10'>
            <button className='btn btn-light-primary' onClick={generateAccessCode}>
              Genera codice d'accesso
            </button>
            {accessCode && (
              <div className='mt-3'>
                Codice generato: <strong>{accessCode}</strong>
              </div>
            )}
          </div>
        </div>

        <div className='modal-footer'>
          <button className='btn btn-light me-3' onClick={handleCloseModal}>
            Annulla
          </button>
          <button className='btn btn-primary' onClick={handleSave}>
            Salva
          </button>
        </div>
      </Modal>
    </div>
  )
}

export default Conferenza